import { render, staticRenderFns } from "./TransferCpfl.vue?vue&type=template&id=38703320&scoped=true&"
import script from "./TransferCpfl.vue?vue&type=script&lang=js&"
export * from "./TransferCpfl.vue?vue&type=script&lang=js&"
import style0 from "./TransferCpfl.vue?vue&type=style&index=0&id=38703320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38703320",
  null
  
)

export default component.exports